export const GoogleAnalyticTags = {
    eventCategory: 'Affiliate Portal',
    eventAction: {
        click: 'Click',
        load: 'Load',
        select: 'Select',
        userId: 'user_id'
    },
    partnerId: {
        name: 'partner_id',
        click: {},
        load: {
            affiliateID: '{{affiliateID}}'
        },
        select: {}
    },
    login: {
        name: 'Login',
        click: {
            becomeAPartnerCTA: 'Login - Become_a _partner_cta_clicked',
            CTA: 'Login - Log_in_cta_clicked',
            forgotPasswordLink: 'Login - Forgot_password_link_clicked'
        },
        load: {
            loginSuccessful: 'Login - Log_in_successful',
            invalidCredentials: 'Login - invalid_credentials_error_loaded'
        },
        select: {

        }
    },
    registration: {
        name: 'Registration',
        click: {
            identityDocumentOptionsByCountry: 'Register client - Identity_documents_see_options_by_country_clicked',
            cta: 'Register_a_customer_cta_clicked',
            confirmCTA: 'Create an account - Confirmation_confirm_cta_clicked',
        },
        load: {
            personalDetailsPageLoad: 'Create an account - Personal_details_pageload',
            loginPageLoad: 'Create an account - Login_details_pageload',
            bankDetailsPageLoad: 'Create an account - Bank_details_pageload',
            clientPageLoad: 'Create an account - Your_clients_pageload',
            confirmationPageLoad: 'Create an account - Confirmation_pageload',
            registrationComplete: 'Create an account - Registration_complete_pageload',

            clientDetailsPageLoad: 'Create an account - Your_clients_pageload',
            addressDetailsPageLoad: 'Create an account - Address_details_pageload',
            identityDocumentPageLoad: 'Create an account - Identity_documents_pageload',
        },
        select: {
            bankDetailsPaymentCurrency: 'Create an account - Bank_details_payment_currency_{{paymentCurrency}}',
            bankDetailsPaymentCountry: 'Create an account - Bank_details_payment_country_{{paymentCountry}}',
            affiliateBusinessSector: '{your_business_sector}',
            affiliateBusinessCategory: '{your_business_category}',
            whichCountriesBased: 'Create an account - Your_clients_which_countries_are_your_clients_based_in_{{clientCountries}}',
            whichLanguagesSpeak: 'Create an account - Your_clients_which_languages_do_you_clients_speak_{{clientLanguages}}',
            whichIndustriesOperate: 'Create an account - Your_clients_which_industries_do_you_operate_in_{{industries}}',
            whichClientsService: 'Create an account - Your_clients_which_clients_do_you_service_{{clientService}}',
            preferencesEstimatedAmt: 'Create an account - Preferences_estimated_amount_{{amount}}',
            identityDocument: {
                bankStatement: 'Register client - Identity_documents_Bank_statement_selected',
                utilityBill: 'Register client - Identity_documents_Utility_bill_selected',
                phoneBill: 'Register client - Identity_documents_Phone_bill_selected',
                other: 'Register client - Identity_documents_Other_selected',
                passport: 'Register client - Identity_documents_Passport_selected',
                nationalIdCard: 'Register client - Identity_documents_National_ID_card_selected',
                drivingLicense: 'Register client - Identity_documents_Driving_license_selected',
            },
        }
    },
    accounts: {
        name: 'Accounts',
        click: {
            summaryViewDetails: 'Account - Account_summary_view_details_clicked',
            tooltip: {
                referrals: 'Account - Your_referrals_tooltip_clicked', //corresponding UI element removed
                registrations: 'Account - Registrations_tooltip_clicked', //corresponding UI element removed
                tradedAccounts: 'Account - Traded_accounts_tooltip_clicked', //corresponding UI element removed
                balance: 'Account - Balance_tooltip_clicked',
                generatedLastMonth: 'Account - Generated_last_month_tooltip_clicked', //corresponding UI element removed
                generatedLastQuarter: 'Account - Generated_last_qrtr_tooltip_clicked',
                paidLastQuarter: 'Account - Paid_last_qrtr_tooltip_clicked',
            },
            commissionsGeneratedViewDetails: 'Account - Commisions_generated_view_details_clicked',
            annualSummaryDownload: 'Account - Annual_summary_download_clicked',
            radioButton: {
                generated: 'Account - Generated_radio_button_clicked',
                paid: 'Account - Paid_radio_button_clicked'
            }
        },
        load: {

        },
        select: {

        }
    },
    referAClient: {
        name: 'Refer a client',
        click: {
            individualButton: 'Refer a client - An_individual_button_clicked',
            companyButton: 'Refer a client - A_company_button_clicked',
            partnerButton: '',
            confirmationCTA: 'Refer a client - Confirmation_confirm_cta_clicked',
        },
        load: {
            personalDetailsPageLoad: 'Refer a client - Personal_details_pageload',
            contactDetailsPageLoad: 'Refer a client - Contact_details_pageload',
            transactionDetailsPageLoad: 'Refer a client - Transaction_details_pageload',
            requirementDetailsPageLoad: 'Refer a client - Requirement_details_pageload',
            confirmationPageLoad: 'Refer a client - Confirmation_pageload',
            clientSuccessfullyReferredPageLoad: 'Refer a client - Client_successfully_referred_pageload'
        },
        select: {
            contactDetailsBestTimeToCall: 'Refer a client - Contact_details_best_time_to_call_{{timeToCall}}',
            transactionDetails: {
                estimatedTransactionValue: 'Refer a client - Transaction_details_estimated_transaction_value_{{transactionValue}}',
                currencyYourClientHas: 'Refer a client - Transaction_details_currency_your_client_has_{{currencyClientHas}}',
                currencyYourClientWants: 'Refer a client - Transaction_details_currency_your_client_wants_{{currencyClientWants}}',
                reasonForTransferring: 'Refer a client - Transaction_details_Reason_for_transferring_{{reasonForTransferring}}', //corresponding UI element removed
            },
            requirementDetails: {
                affiliateReferredClientTypes: '{affiliate_client_types}'
            }
        }
    },
    clientManagement: {
        name: 'Client Management',
        click: {
            filterTableCTA: 'Client Management - client_management_filter_cta_clicked',
            exportTableCTA: 'Client Management - client_management_export_cta_clicked',
            viewDetailsButton: 'Client Management - client_management_view_details_cta_clicked'
        },
        load: {
            clientManagementPageLoad: 'Client Management - client_management_pageload'
        }
    },
    resources: {
        name: 'Resources',
        click: {
            loadMoreCTA: 'Resources - Load more_cta_clicked',
            affiliateTrackingCodeLink: 'Resources - Affiliate_tracking_code_link_clicked'
        },
        load: {

        },
        select: {
            filter: {
                categories: 'Resources - Filter_Categories - {{filterCategories}}',
                industry: 'Resources - Filter_Industry - {{filterIndustry}}',
                clientType: 'Resources - Filter_Client type - {{filterClientType}}',
                countries: 'Resources - Filter_Countries - {{filterCountries}}'
            }
        }
    },
    commissions: {
        name: 'Commissions',
        click: {
            radioButton: {
                generated: 'Commissions - Generated_radio_button_clicked',
                paid: 'Commissions - Paid_radio_button_clicked'
            },
            tooltip: {
                balance: 'Commissions - Balance_tooltip_clicked',
                generatedLastMonth: 'Commissions - Generated_last_month_tooltip_clicked', //corresponding UI element removed
                generatedLastQuarter: 'Commissions - Generated_last_qrtr_tooltip_clicked',
                paidLastMonth: 'Commissions - Paid_last_month_tooltip_clicked', //corresponding UI element removed
                paidLastQuarter: 'Commissions - Paid_last_qrtr_tooltip_clicked',
            },
            downloadLink: 'Commissions - Download_link_clicked',
            firstTier: 'Commissions - First_tier_clicked',
            secondTier: 'Commissions - Second_tier_clicked',
            thirdTier: 'Commissions - Third_tier_clicked'
        },
        load: {

        },
        select: {
            filterMonth: 'Commissions - Filter_Month - {{filterMonth}}'
        }
    },
    referrals: {
        name: 'Referrals',
        click: {
            tooltip: {
                yourReferrals: 'Referrals - Your_referrals_tooltip_clicked', //corresponding UI element removed
                registration: 'Referrals - Registrations_tooltip_clicked', //corresponding UI element removed
                tradedAccounts: 'Referrals - Traded_accounts_tooltip_clicked', //corresponding UI element removed
            },
            radioButton: {
                referrals: 'Referrals - Referrals_radio_button_clicked',
                registrations: 'Referrals - Registrations_radio_button_clicked',
                tradedAccounts: 'Referrals - Traded_accounts_radio_button_clicked',
            },
            filter: {
                referral: 'Referrals - Filter_Referrals_clicked',
                registration: 'Referrals - Filter_Registrations_clicked',
                trades: 'Referrals - Filter_Trades_clicked'
            },
            downloadLink: 'Referrals - Download_link_clicked',
        },
        load: {

        },
        select: {
            filterMonth: 'Referrals - Filter_Month - {{filterMonth}}'
        }
    },
    settings: {
        name: 'Settings',
        click: {

        },
        load: {

        },
        select: {
            whichClientsDoYouService: 'Settings - Which_clients_do_you_service_{{clients}}',
            whoAreYourCustomers: 'Settings - Who_are_your_customers_{{customers}}',
            whichCountriesAreYourClientsBasedIn: 'Settings - Which_countries_are_your_clients_based_in_{{countries}}',
            languages: 'Settings - Languages_{{languages}}',
            whatUpdatesWouldYouLikeFromUs: 'Settings - What_updates_would_you_like_from_us_{{updates}}', //Tag not in use
            emailPreferences: 'Settings - Email_preferences_{{emailPreferences}}',
            whichIndustriesYouOperate: 'Settings - Who_are_your_customers_{{industry}}',
        }
    },
    registerClient: {
        name: 'Register customer',
        click: {
            referralURLGeneratorGenerateURLCTA: 'Referral URL generator - generate_url_cta_clicked',
            ConfirmationCtaClicked: 'Register client - Confirmation_confirm_cta_clicked',
            identityDocumentsSkipThisStepClicked: 'Register client - Identity_documents_skip_this_step_clicked',
            contactYourPartnerManagerBackToAccountCtaClicked: 'Register client  - Registration_failed_contact_your_partner_manage_Back_to_account_cta_clicked',
            contactYourPartnerManagerRegisterNewClientCtaClicked: 'Register client - Registration_failed_contact_your_partner_manage_Register_new_client_cta_clicked',
            whyDoWeNeedThisLinkClicked: 'Register client - client_details_why_do_we_need_this',
            clientDetailsContinueCtaClicked: 'Register client - client_details_continue_cta',
            addressDetailsContinueCtaClicked: 'Register client - address_details_continue_cta'
        },
        load: {
            customerDetailsPageLoad: 'Register client - Client_details_pageload',
            addressDetailsPageLoad: 'Register client - Address_details_pageload',
            preferencesPageLoad: 'Register client - Preferences_pageload',
            confirmation: 'Register client - Confirmation',
            referralURLGeneratorPageLoad: 'Referral URL generator - pageload',
            identityDocumentsPageLoad: 'Register client - Identity_documents_pageload',
            referralURLGeneratorSuccessfully: 'Referral URL generator - url_sent_successfully',
            referralURLGeneratorFail: 'Referral URL generator - url_send_error',
            clientSuccessfullyRegisteredPageload: 'Register client - Client_successfully_registered_pageload',
            ContactYourPartnerManagerPageLoad: 'Register client  - Registration_failed_contact_your_partner_manager_pageload'
        },
        select: {
            transactionDetails: {
                estimatedTransactionValue: 'Register client - Preferences_estimated_amount_{{transactionValue}}',
                currencyYourClientHas: 'Register client - Transaction_details_currency_your_client_has_{{currencyClientHas}}',//not in master sheet
                currencyYourClientWants: 'Register client - Transaction_details_currency_your_client_wants_{{currencyClientWants}}'//not in master sheet
            },
            identityDocument: {
                bankStatement: 'Register client - Identity_documents_Bank_statement_selected',
                utilityBill: 'Register client - Identity_documents_Utility_bill_selected',
                phoneBill: 'Register client - Identity_documents_Phone_bill_selected',
                other: 'Register client - Identity_documents_Other_selected',
                passport: 'Register client - Identity_documents_Passport_selected',
                nationalIdCard: 'Register client - Identity_documents_National_ID_card_selected',
                drivingLicense: 'Register client - Identity_documents_Driving_license_selected',
            },
            clientDetailsEmployment: 'client_details_employment_{{employmentStatus}}',
            clientDetailsWorkIndustry: 'client_details_work_industry_{{workIndustry}}'
        }
    },
    globalCTAs: {
        click: {
            sendRegistrationLink: 'Send_registration_link_cta_clicked',
            registerAClientClicked: 'Register_a_client_cta_clicked',
        }
    },
    menuClicks: {
        click: {
            contact: 'contact',
            account: 'account',
            makeAReferral: 'make_a_referral',
            resources: 'resources',
            referralActivity: 'referral_activity',
            commissions: 'commissions',
            invoices: 'invoices',
            settings: 'settings'
        }
    }
};
